module.exports = __webpack_public_path__ + "static/media/temporary.f90acc41.png";